<template>
  <div class="document-notification" data-testid="document-notification">
    <c-alert
      :show="show"
      type="bell"
      :message="t('document.unsingedDocumentNotification')"
      hide-close-button
      hoverable
      @click="alertClick"
    ></c-alert>
  </div>
  <document-detail-dialog ref="refDocumentDetailDialog" @saved="fetchDocuments" />
</template>

<script lang="ts" setup>
import CAlert from '@/components/_common/CommonAlert.vue';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import { hubClient } from '@tfpl/api-client';
import DocumentDetailDialog from '@/components/documents/DocumentDetailDialog.vue';
import documentsModule from '@/store/modules/DocumentsModule';
import { useAuthStore } from '@/store/auth';

/*****************************************************************************
 * PROPS
 ****************************************************************************/
const props = defineProps<{
  unsignedDocument: hubClient.DocumentDto;
}>();

/*****************************************************************************
 * SETUP
 ****************************************************************************/
const refDocumentDetailDialog = ref(DocumentDetailDialog);

const show = ref(true);
const { t } = useI18n();
const authStore = useAuthStore();

const fetchDocuments = () => {
  documentsModule.fetchDocuments({
    uuid: authStore.currentUser?.uuid as string,
    month: '',
  });
};

const alertClick = () => {
  if (refDocumentDetailDialog.value) {
    refDocumentDetailDialog.value.openDialog(props.unsignedDocument);
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/app.variables.scss';
</style>
